import { toJalaali } from "jalaali-js";

export function isoToJalali(isoString) {
  const date = new Date(isoString);
  const { jy, jm, jd } = toJalaali(date);

  return `${jy}/${String(jm).padStart(2, "0")}/${String(jd).padStart(2, "0")}`;
}

function getPersianDateTimeParts(date, timeZone) {
  return Object.fromEntries(
    new Intl.DateTimeFormat("en-US-u-ca-persian", {
      timeZone,
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: false,
    })
      .formatToParts(date)
      .filter((part) => part.type !== "literal")
      .map((part) => [part.type, part.value]),
  );
}

export function isoToJalaliDateTime(
  isoString,
  { timeZone = "Asia/Tehran" } = {},
) {
  if (!isoString) return "";

  const date = new Date(isoString);
  if (Number.isNaN(date.getTime())) {
    return String(isoString);
  }

  const { year, month, day, hour, minute, second } =
    getPersianDateTimeParts(date, timeZone);

  return `${year}/${month}/${day} ${hour}:${minute}:${second}`;
}
